/* ==========================================================================
   Vizion Concepts – sticky Add to Cart bar (snippets/vc-sticky-atc.liquid)
   Slides up once the shopper has scrolled past the price and the real Add to
   Cart button is off screen. Mirrors the real button's total, text and
   disabled state, and clicks the real button so YMQ's required fields are
   still checked.
   ========================================================================== */
(function () {
  function init(bar) {
    var section = document.querySelector('.product-section[data-section-id="' + bar.getAttribute('data-section-id') + '"]');
    var mainBtn = section && section.querySelector('form.product-single__form [data-add-to-cart]');
    if (!mainBtn) return;

    var priceBlock = section.querySelector('.product-block--price') || section.querySelector('.product-single__title');
    var stickyBtn = bar.querySelector('[data-vc-sticky-btn]');
    var stickyText = bar.querySelector('[data-vc-sticky-text]');
    var stickyAmount = bar.querySelector('[data-vc-sticky-amount]');

    // ---- Mirror the real button ----
    function mirror() {
      var mainText = mainBtn.querySelector('[data-add-to-cart-text]');
      var mainAmount = mainBtn.querySelector('[data-vc-atc-total-amount]');
      if (mainText) stickyText.textContent = mainText.textContent.trim();
      if (mainAmount && stickyAmount.textContent !== mainAmount.textContent) {
        stickyAmount.textContent = mainAmount.textContent;
      }
      stickyBtn.disabled = mainBtn.disabled;
    }
    new MutationObserver(mirror).observe(mainBtn, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });
    mirror();

    // ---- Show / hide ----
    var mainVisible = true;
    var pastPrice = false;
    var typing = false;

    function render() {
      var show = !mainVisible && pastPrice && !typing;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('vc-sticky-atc-open', show);
      if (show) {
        bar.removeAttribute('aria-hidden');
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
      }
    }

    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      render();
    }).observe(mainBtn);

    if (priceBlock) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        pastPrice = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        render();
      }).observe(priceBlock);
    } else {
      pastPrice = true;
    }

    // Phones: get out of the way while the keyboard is up, so the bar never covers the field being typed in
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      var isTextField = function (el) {
        if (!el || !el.tagName) return false;
        if (el.tagName === 'TEXTAREA') return true;
        if (el.tagName !== 'INPUT') return false;
        return !/^(radio|checkbox|button|submit|reset|file|image|range|color|hidden)$/i.test(el.type);
      };
      document.addEventListener('focusin', function (evt) {
        if (isTextField(evt.target)) {
          typing = true;
          render();
        }
      });
      document.addEventListener('focusout', function (evt) {
        if (isTextField(evt.target)) {
          typing = false;
          render();
        }
      });
    }

    // ---- Click: use the real button so validation and the cart drawer behave as normal ----
    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
      // If YMQ flags a missing required option, take the shopper to it
      setTimeout(function () {
        var error = section.querySelector('#ymq-box .ymq-error-box:not(:empty)');
        if (error) {
          var field = error.closest('.ymq-options-box') || error;
          field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 250);
    });
  }

  function start() {
    document.querySelectorAll('[data-vc-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
